import { render, staticRenderFns } from "./checkboxes-for-modal.vue?vue&type=template&id=9fc0fa4c&scoped=true"
import script from "./checkboxes-for-modal.vue?vue&type=script&lang=js"
export * from "./checkboxes-for-modal.vue?vue&type=script&lang=js"
import style0 from "./checkboxes-for-modal.vue?vue&type=style&index=0&id=9fc0fa4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc0fa4c",
  null
  
)

export default component.exports